module.exports = __webpack_public_path__ + "img/pesaj-2020-thumbnail.71f79e23.jpeg";